import { Capacitor } from "@capacitor/core";
import { Network } from "@capacitor/network";
import * as Sentry from "@sentry/capacitor";

export class SystemLogService {
  private static logEnabled: boolean = false;
  private initialized = false;

  public isInitialized(): boolean {
    return this.initialized;
  }

  static enableLogging() {
    this.logEnabled = true;
  }

  static logMessage(message: string | null) {
    if (!this.logEnabled) {
      return;
    }
    if (!message)
      return;
  }

  static logError(errorObject: unknown, statusText: string = 'error', title: string = 'error') {
  const isString = (val: any): val is string =>
    typeof val === 'string' || val instanceof String;

  if (isString(errorObject)) {
    Sentry.captureMessage(errorObject, {
      level: 'error',
      tags: { statusText, title }
    });
  } else if (errorObject instanceof Error) {
    Sentry.captureException(errorObject, {
      tags: { statusText, title }
    });
  } else if (typeof errorObject === 'object' && errorObject !== null) {
    const context: any = errorObject;
    const message =
      context.message ||
      context.error?.message ||
      context.statusText ||
      'Unknown error object';

    Sentry.captureMessage(message, {
      level: 'error',
      tags: { statusText, title },
      extra: { error: context }
    });
  } else if (errorObject === null || errorObject === undefined) {
    // No error object (e.g. network failed without an exception). Use statusText/title as message.
    Sentry.captureMessage(statusText || title || 'Error (no details)', {
      level: 'error',
      tags: { statusText, title }
    });
  } else {
    // number, boolean, symbol, etc.
    Sentry.captureMessage(
      `Invalid or empty error object: ${String(errorObject)}`,
      {
        level: 'error',
        tags: { statusText, title }
      }
    );
  }
}
}


